import SearchableDropdown from '../../../../components/SearchableDropdown';
import { financialYears } from '../../../../consts/DropDownOptions';
import { getCurrentFY } from './helpers';

const inputClass = 'tw-w-full tw-px-2.5 tw-py-1.5 tw-text-xs tw-border tw-border-gray-200 tw-rounded-md focus:tw-outline-none focus:tw-border-rose-500';
const labelClass = 'tw-block tw-text-[10px] tw-font-medium tw-text-gray-500 tw-uppercase tw-mb-1';

export const FinancialYearField = ({ value, onChange }) => {
    const isCurrent = value === getCurrentFY();
    return (
        <div>
            <label className={labelClass}>Financial Year</label>
            <div className="tw-relative">
                <SearchableDropdown
                    value={value}
                    onChange={onChange}
                    options={financialYears}
                    placeholder="Select FY"
                    clearable={false}
                    small
                />
                {isCurrent && (
                    <span className="tw-absolute tw-top-1/2 tw-right-9 tw--translate-y-1/2 tw-text-[9px] tw-bg-emerald-100 tw-text-emerald-700 tw-px-1.5 tw-py-0.5 tw-rounded tw-font-semibold tw-pointer-events-none">
                        Current
                    </span>
                )}
            </div>
        </div>
    );
};

export const DateField = ({ label, value, onChange }) => (
    <div>
        <label className={labelClass}>{label}</label>
        <input type="date" value={value || ''} onChange={(e) => onChange(e.target.value)} className={inputClass} />
    </div>
);

export const GetReportButton = ({ onClick, loading, label = 'Get Report' }) => (
    <button
        onClick={onClick}
        disabled={loading}
        className="tw-flex tw-items-center tw-gap-1.5 tw-px-4 tw-py-1.5 tw-rounded-md tw-text-xs tw-font-medium tw-text-white tw-bg-rose-600 hover:tw-bg-rose-700 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-transition-colors"
    >
        {loading && <div className="tw-animate-spin tw-rounded-full tw-h-3 tw-w-3 tw-border-2 tw-border-white tw-border-t-transparent"></div>}
        {label}
    </button>
);
